import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './Component/Navbar';
import Feature from './Component/Feature';
import Price from './Component/Price';
import Contact from './Component/Contact';
import Home from './Component/Home';
import Terms_Condition from './Component/Terms_Condition';
import Privacy_Policy from './Component/Privacy_Policy';
import RegisterCompanyFlow from './Component/Register';
import BestoHrmsChatWidget from './Component/BestoHrmsChatWidget';
import CompleteRegistration from './Component/CompleteRegistration';

// Admin imports
import { AdminAuthProvider, useAdminAuth } from './context/AdminAuthContext';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import TenantsListPage from './pages/admin/TenantsListPage';
import TenantDetailsPage from './pages/admin/TenantDetailsPage';
import LicensesListPage from './pages/admin/LicensesListPage';
import PaymentsListPage from './pages/admin/PaymentsListPage';

// Protected Admin Route Component
const ProtectedAdminRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

// Admin Routes Wrapper with Provider
const AdminRoutes = () => {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route path="dashboard" element={
          <ProtectedAdminRoute>
            <AdminDashboard />
          </ProtectedAdminRoute>
        } />
        <Route path="tenants" element={
          <ProtectedAdminRoute>
            <TenantsListPage />
          </ProtectedAdminRoute>
        } />
        <Route path="tenants/:id" element={
          <ProtectedAdminRoute>
            <TenantDetailsPage />
          </ProtectedAdminRoute>
        } />
        <Route path="licenses" element={
          <ProtectedAdminRoute>
            <LicensesListPage />
          </ProtectedAdminRoute>
        } />
        <Route path="payments" element={
          <ProtectedAdminRoute>
            <PaymentsListPage />
          </ProtectedAdminRoute>
        } />
        <Route path="" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </AdminAuthProvider>
  );
};

// Landing Page Layout (with Navbar and Chat Widget)
const LandingLayout = ({ children, contactRef }) => {
  return (
    <>
      <Navbar scrollToContact={() => contactRef.current?.scrollIntoView({ behavior: 'smooth' })} />
      {children}
      <BestoHrmsChatWidget />
    </>
  );
};

function App() {
  const contactRef = useRef(null);

  return (
    <Router>
      <Routes>
        {/* Admin Routes - No Navbar or Chat Widget */}
        <Route path="/admin/*" element={<AdminRoutes />} />

        {/* Landing Page Routes */}
        <Route path="/" element={
          <LandingLayout contactRef={contactRef}>
            <Home contactRef={contactRef} />
          </LandingLayout>
        } />
        <Route path="/terms_condition" element={
          <LandingLayout contactRef={contactRef}>
            <Terms_Condition />
          </LandingLayout>
        } />
        <Route path="/privacy_policy" element={
          <LandingLayout contactRef={contactRef}>
            <Privacy_Policy />
          </LandingLayout>
        } />
        <Route path="/contact" element={
          <LandingLayout contactRef={contactRef}>
            <Contact />
          </LandingLayout>
        } />
        <Route path="/register" element={
          <LandingLayout contactRef={contactRef}>
            <RegisterCompanyFlow />
          </LandingLayout>
        } />
        <Route path="/complete-registration/:token" element={
          <LandingLayout contactRef={contactRef}>
            <CompleteRegistration />
          </LandingLayout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
